var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostfullyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 28,
    viewBox: "0 0 98 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4236_47645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4236_47645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 5,
    width: 98,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0115 15.0489V8.64578L15.0354 11.1057V23.3693H11.0115V18.8473H5.561V23.3693H1.53711V11.1057L5.561 8.64578V15.0127H11.0115V15.0489ZM93.7939 10.9972H98.0373L97.9641 11.2504L93.8671 22.7543C92.5136 26.5528 90.3187 28.1445 86.8436 27.9636H86.6607V24.3099H86.8436C88.4165 24.3099 89.1482 23.8396 89.6603 22.5373L84.795 11.0334H89.1482L91.6722 17.9068L93.7939 10.9972ZM79.6371 5.53467H83.5879V23.2246H79.6371V5.53467ZM73.6745 5.53467H77.6252V23.2246H73.6745V5.53467ZM67.7484 22.4287C67.0168 23.1522 65.8462 23.5863 64.4927 23.5863C61.7857 23.5863 59.8103 21.5967 59.8103 18.4856V10.9972H63.7611V17.9429C63.7611 19.2091 64.4927 19.9326 65.6633 19.9326C66.9802 19.9326 67.7118 19.1729 67.7118 17.6535V10.9972H71.6991V23.2246H67.7484V22.4287ZM58.274 5.9326H58.4569V9.73105H58.274C56.9936 9.62252 56.2986 10.0205 56.262 11.0334H58.4934V14.8318H56.262V23.2969H52.3113V14.7957H50.7017V10.9972H52.3113C52.3113 7.52433 54.3964 5.67937 58.274 5.9326ZM47.0802 10.9972H49.5677V14.7957H47.0802V18.8112C47.0802 19.5708 47.6289 19.7517 49.3482 19.6432H49.5311V23.2246H49.3848C44.7756 23.6949 43.0929 22.4287 43.0929 18.8112V14.7957H41.1541V10.9972H43.0929V8.79048L47.0436 7.59668V10.9972H47.0802ZM34.7159 14.6509C34.7159 14.868 35.0451 15.0489 35.8499 15.3021C35.9962 15.3383 36.5815 15.483 36.6547 15.5192C36.9839 15.6277 37.2766 15.7 37.5326 15.7724C39.5446 16.4236 40.6054 17.5088 40.6054 19.4985C40.6054 22.1031 38.4472 23.5863 35.4109 23.5863C32.8869 23.5863 31.0212 22.6096 30.0701 20.6561L29.997 20.5114L33.4722 18.5579L33.5453 18.775C33.838 19.607 34.4598 20.0411 35.4109 20.0411C36.1791 20.0411 36.5084 19.8241 36.5084 19.4985C36.5084 19.2814 36.1791 19.1006 35.4109 18.8473C35.228 18.8112 34.533 18.5941 34.6062 18.6303C34.2404 18.5217 33.9843 18.4494 33.6916 18.3409C31.6797 17.6535 30.6189 16.6044 30.6189 14.7595C30.6189 12.2272 32.6674 10.6716 35.5207 10.6716C37.5692 10.6716 39.3617 11.6122 40.3494 13.3124L40.4591 13.4571L37.0571 15.2659L36.9839 15.1212C36.6547 14.4701 36.1791 14.1807 35.5207 14.1807C35.0086 14.1445 34.7159 14.3615 34.7159 14.6509ZM23.01 19.7517C24.5099 19.7517 25.5707 18.6665 25.5707 17.1471C25.5707 15.5915 24.4733 14.5424 23.01 14.5424C21.5102 14.5424 20.4494 15.6277 20.4494 17.1471C20.4128 18.6665 21.5102 19.7517 23.01 19.7517ZM23.01 23.5502C19.352 23.5502 16.4621 20.7285 16.4621 17.1109C16.4621 13.4933 19.352 10.6716 23.01 10.6716C26.6681 10.6716 29.558 13.4933 29.558 17.1109C29.558 20.7285 26.6681 23.5502 23.01 23.5502Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4236_47645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4236_47645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0366 0H0V28.2171H98.0366V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4236_47645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8287 3.72607H-0.292969V29.8088H99.8287V3.72607Z",
    fill: "#2D2AA5"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4236_47645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5711 8.97158L8.30384 4.12403L0 8.97158V4.84755L8.30384 0L16.5711 4.84755V8.97158Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4236_47645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4236_47645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 29
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0366 0H0V28.2171H98.0366V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4236_47645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4011 -1.80859H-1.82812V10.7806H18.4011V-1.80859Z",
    fill: "#40CAA1"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4236_47645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 9,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.572 8.97158L8.30469 4.12403V0L16.572 4.84755V8.97158Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4236_47645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4236_47645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 29
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0366 0H0V28.2171H98.0366V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4236_47645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4365 -1.80859H6.47461V10.7806H18.4365V-1.80859Z",
    fill: "#33AE8A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4236_47645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostfullyLogo);
export default __webpack_public_path__ + "static/media/hostfully-logo.5bd3c28a97941989d250f4fa5fd30506.svg";
export { ForwardRef as ReactComponent };